// App base url will be fetched from browser of ui

// Patch Base URL
// export const APP_BASE_URL = "patch.qualdo.ai"

// Dev Base URL
//export const APP_BASE_URL = "dev-saas-azure.qualdo.ai"

//export const APP_BASE_URL = "qdq-h6zeltyfv5soig0l.azure-qualdo.ai"

//export const APP_BASE_URL = "qdq-cq1bvcnuc094ueup.azure-qualdo.ai"
// Staging Base URL
// export const APP_BASE_URL = "dev-saas-azure.qualdo.ai"

// Instance Base URL
// export const APP_BASE_URL = "qdq-gbo62xc3d75aki2w.azure-qualdo.ai"


export const APP_BASE_URL = window.location.hostname
export const iam_ip = APP_BASE_URL+"/iam"
export const iam_google_signup = APP_BASE_URL+"/iam"
export const ui_service_ip = APP_BASE_URL+"/ui-api-service"
export const console_ip = APP_BASE_URL+"/console"
export const intelligence_ip = APP_BASE_URL+"/intelligence"

// Powerbi base url will be fetched from env variable.
export const powerbi_service_ip = process.env.REACT_APP_POWERBI_BASE_URL + "/ui-api-service"
